module.exports = __webpack_public_path__ + "img/home_section.24ac6b0b.webp";